import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <main className="min-h-screen bg-background-50 flex items-center justify-center px-6">
      <div className="text-center max-w-lg">
        <div className="text-8xl md:text-9xl font-bold text-background-200 select-none mb-4">
          404
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          Seite nicht gefunden
        </h1>
        <p className="text-sm text-foreground-400 font-mono mb-2">
          {location.pathname}
        </p>
        <p className="text-base text-foreground-500 mb-8 leading-relaxed">
          Die gesuchte Seite existiert nicht. Vielleicht hast du dich vertippt oder der Link ist veraltet.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          Zurück zur Startseite
        </Link>
      </div>
    </main>
  );
}